import ApiClient from '@/api/client';
const path = require('path');

class GeospatialAPI extends ApiClient {

  constructor() {
    super();
  }
  
  async getResourceGeographicLayerScenarios(id) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${id}/_scenarios/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runResourceGeographicLayerScenario(id, scenarioId) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${id}/_scenarios/${scenarioId}/run/?asynchrone=false`
    );
    const response = await this.post(route);
    if (response.status === 202) {
      return response.data;
    }
    return false;
  }
  async getGeographicLayerStylesList(geographiclayerId) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async createGeographicLayerStyle(id, payload) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${id}/style/`
    );
    const response = await this.post(route, payload);
    if (response.status === 201) {
      return response.data;
    }
    return false;
  }
  async getGeographicLayerStyle(geographiclayerId, styleId) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/${styleId}/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async updateGeographicLayerStyle(geographiclayerId, styleId, payload) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/${styleId}/`
    );
    const response = await this.put(route, payload);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async deleteGeographicLayerStyle(geographiclayerId, styleId) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/${styleId}/`
    );
    const response = await this.delete(route);
    if (response.status === 204) {
      return response.data;
    }
    return false;
  }

  // Config
  async setGeographicLayerStyleConfig(geographiclayerId, styleId, config) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/${styleId}/config/`
    );
    const response = await this.put(route, config);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async getGeographicLayerStyleConfig(geographiclayerId, styleId) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/${styleId}/config/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  // Scenario
  async getGeographicLayerStyleScenarios(geographiclayerId, styleId) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/${styleId}/_scenarios/`
    );
    const response = await this.get(route);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
  async runGeographicLayerStyleScenario(geographiclayerId, styleId, scenarioId, data) {
    const route = path.join(
      this.GEOSPATIAL_API_PATH,
      `/geographiclayer/${geographiclayerId}/style/${styleId}/_scenarios/${scenarioId}/run/?asynchrone=true`
    );
    const response = await this.post(route, data);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
}

const geospatialAPI = new GeospatialAPI();
export default geospatialAPI;